window.toastLoaded = false;

// Check for initial toast data on first load
function checkInitialToast() {
  if (!window.toastLoaded) {
    window.toastLoaded = true;
    let toastData = document.getElementById("toast-data");
    if (toastData) {
      let data = toastData.getAttribute("data-data");
      if (data) {
        try {
          data = JSON.parse(data);
          if (data.message) {
            dumpToast(data);
          }
        } catch (e) {
          console.error("Error parsing toast data:", e);
        }
      }
    }
  }
}

function sortToast() {
  let containers = document.querySelectorAll(".toast-container");
  for (let i = 0; i < containers.length; i++) {
    containers[i].style.top = (12 + i * 70) + "px";
  }
}

function dismissScheduler(container, time) {
  setTimeout(function() {
    dismissToast(container);
  }, time);
}

function dismissToast(container) {
  try {
    container.style.top = "-100px";
    setTimeout(() => {
      container.remove();
      sortToast();
    }, 200);
  } catch (e) {
    console.error("Error dismissing toast:", e);
  }
}

// Make dumpToast globally available
window.dumpToast = function dumpToast(data) {
  let _message = data.message;
  let type = data.type || "success";
  let time = parseInt(data.time || 4) * 1000;

  let container = document.createElement("div");
  let message = document.createElement("div");
  let close = document.createElement("div");
  close.innerHTML = "×";

  container.style.height = "60px";
  container.style.alignItems = "center";

  let toastContainerCount = document.getElementsByClassName("toast-container").length;
  setTimeout(function() {
    container.style.top = (12 + toastContainerCount * 70) + "px";
  }, 20);

  container.classList.add("toast-container");
  container.classList.add(type);
  message.classList.add("message");
  close.classList.add("close");

  message.innerHTML = _message;
  container.appendChild(message);
  container.appendChild(close);

  close.addEventListener("click", () => dismissToast(container));
  dismissScheduler(container, time);
  document.body.appendChild(container);
}

// Check for initial toast data when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkInitialToast);
} else {
  checkInitialToast();
}

// Also add toast listener here as backup (will be removed if already added in layout)
if (window.Livewire && (typeof window.dumpToast === 'function' || typeof dumpToast === 'function') && !window.vendorToastListenerAdded) {
  const toastFunc = window.dumpToast || dumpToast;
  
  window.vendorToastHandler = function(data) {
    // Handle both array format [data] and direct object format
    let toastData = null;
    if (Array.isArray(data) && data.length > 0) {
      toastData = data[0];
    } else if (data && typeof data === 'object' && data.message) {
      toastData = data;
    } else if (data && data.message) {
      toastData = data;
    }
    
    if (toastData && toastData.message) {
      toastFunc(toastData);
    }
  };
  
  window.Livewire.on("toast", window.vendorToastHandler);
}
